/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clinicsControllerCreate } from '../fn/clinics/clinics-controller-create';
import { ClinicsControllerCreate$Params } from '../fn/clinics/clinics-controller-create';
import { clinicsControllerDelete } from '../fn/clinics/clinics-controller-delete';
import { ClinicsControllerDelete$Params } from '../fn/clinics/clinics-controller-delete';
import { clinicsControllerFilter } from '../fn/clinics/clinics-controller-filter';
import { ClinicsControllerFilter$Params } from '../fn/clinics/clinics-controller-filter';
import { clinicsControllerFindOne } from '../fn/clinics/clinics-controller-find-one';
import { ClinicsControllerFindOne$Params } from '../fn/clinics/clinics-controller-find-one';
import { clinicsControllerHandleEvents } from '../fn/clinics/clinics-controller-handle-events';
import { ClinicsControllerHandleEvents$Params } from '../fn/clinics/clinics-controller-handle-events';
import { clinicsControllerReactivate } from '../fn/clinics/clinics-controller-reactivate';
import { ClinicsControllerReactivate$Params } from '../fn/clinics/clinics-controller-reactivate';
import { clinicsControllerUpdate } from '../fn/clinics/clinics-controller-update';
import { ClinicsControllerUpdate$Params } from '../fn/clinics/clinics-controller-update';
import { ResponseClinicDto } from '../models/response-clinic-dto';

@Injectable({ providedIn: 'root' })
export class ClinicsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clinicsControllerHandleEvents()` */
  static readonly ClinicsControllerHandleEventsPath = '/thalea-clinics/clinics/cognito';

  /**
   * Handle SQS events for doctor creation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerHandleEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerHandleEvents$Response(params?: ClinicsControllerHandleEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clinicsControllerHandleEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Handle SQS events for doctor creation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerHandleEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerHandleEvents(params?: ClinicsControllerHandleEvents$Params, context?: HttpContext): Observable<void> {
    return this.clinicsControllerHandleEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clinicsControllerCreate()` */
  static readonly ClinicsControllerCreatePath = '/thalea-clinics/clinics';

  /**
   * Create a clinic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicsControllerCreate$Response(params: ClinicsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDto>> {
    return clinicsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a clinic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicsControllerCreate(params: ClinicsControllerCreate$Params, context?: HttpContext): Observable<ResponseClinicDto> {
    return this.clinicsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicDto>): ResponseClinicDto => r.body)
    );
  }

  /** Path part for operation `clinicsControllerFindOne()` */
  static readonly ClinicsControllerFindOnePath = '/thalea-clinics/clinics/{tenant}/{id}';

  /**
   * Find a clinic by tenant and creation date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerFindOne$Response(params: ClinicsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDto>> {
    return clinicsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Find a clinic by tenant and creation date.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerFindOne(params: ClinicsControllerFindOne$Params, context?: HttpContext): Observable<ResponseClinicDto> {
    return this.clinicsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicDto>): ResponseClinicDto => r.body)
    );
  }

  /** Path part for operation `clinicsControllerUpdate()` */
  static readonly ClinicsControllerUpdatePath = '/thalea-clinics/clinics/{tenant}/{id}';

  /**
   * Update a clinic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicsControllerUpdate$Response(params: ClinicsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDto>> {
    return clinicsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a clinic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicsControllerUpdate(params: ClinicsControllerUpdate$Params, context?: HttpContext): Observable<ResponseClinicDto> {
    return this.clinicsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseClinicDto>): ResponseClinicDto => r.body)
    );
  }

  /** Path part for operation `clinicsControllerDelete()` */
  static readonly ClinicsControllerDeletePath = '/thalea-clinics/clinics/{tenant}/{id}';

  /**
   * Delete a clinic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerDelete$Response(params: ClinicsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clinicsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a clinic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerDelete(params: ClinicsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.clinicsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clinicsControllerReactivate()` */
  static readonly ClinicsControllerReactivatePath = '/thalea-clinics/clinics/{tenant}/{id}/reactivate';

  /**
   * Reactivate a clinic.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerReactivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerReactivate$Response(params: ClinicsControllerReactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clinicsControllerReactivate(this.http, this.rootUrl, params, context);
  }

  /**
   * Reactivate a clinic.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerReactivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clinicsControllerReactivate(params: ClinicsControllerReactivate$Params, context?: HttpContext): Observable<void> {
    return this.clinicsControllerReactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clinicsControllerFilter()` */
  static readonly ClinicsControllerFilterPath = '/thalea-clinics/clinics/filter';

  /**
   * Filter clinics based on query parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clinicsControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicsControllerFilter$Response(params: ClinicsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicDto>>> {
    return clinicsControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter clinics based on query parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clinicsControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clinicsControllerFilter(params: ClinicsControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseClinicDto>> {
    return this.clinicsControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseClinicDto>>): Array<ResponseClinicDto> => r.body)
    );
  }

}
